import {Client, IMessage} from "@stomp/stompjs";

import {Observable} from "rxjs";

export function observableTopic(client: Client, topic: string): Observable<IMessage> {
  return new Observable((subscriber) => {
    const subscription = client.subscribe(topic, message => subscriber.next(message));
    return () => subscription.unsubscribe();
  });
}
